import React from 'react'
import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    AlertDialogCloseButton,
    Button, useToast
} from '@chakra-ui/react'
import { useTestsStore } from '../../store/testsStore'
import { toastError, toastSuccess } from '../../utils/globalHelper'
import { useAccessAPI } from '../../hooks/useAccessAPI'
import TestsService from '../../API/TestsService'

function DeleteTestAlert({isOpen, onClose, test}) {
    const toast = useToast()
    const [tests, setTests] = useTestsStore(state => [state.tests, state.setTests])
    const cancelRef = React.useRef()
    const deleteTest = useAccessAPI(TestsService.deleteTest)

    const onDeleteTest = async () => {
        const response = await deleteTest(test.id)
        if (response?.status) {
            setTests(tests.filter((el) => el.id !== test.id))
            toast(toastSuccess('Зачёт удалён'))
        } else {
            toast(toastError('Не удалось удалить зачёт'))
        }

        onClose()
    }

    return (
        <AlertDialog
            isOpen={isOpen}
            onClose={onClose}
            leastDestructiveRef={cancelRef}
        >
            <AlertDialogOverlay>
                <AlertDialogContent>
                    <AlertDialogHeader>
                        Удаление зачёта
                    </AlertDialogHeader>
                    <AlertDialogCloseButton />

                    <AlertDialogBody>
                        Вы действительно хотите удалить зачёт?
                    </AlertDialogBody>

                    <AlertDialogFooter>
                        <Button
                            ref={cancelRef}
                            onClick={onClose}
                            mr='var(--default-gap)'
                            variant='secondary'
                        >
                            Отмена
                        </Button>
                        <Button onClick={onDeleteTest}>
                            Удалить
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    )
}

export default DeleteTestAlert
